import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
// import {Icon} from "@iconify/react";

// Convert 24-hour time format to 12-hour time format with AM/PM
const convertTimeTo12Hour = (time) => {
  const [hour, minute] = time.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const adjustedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM/PM
  return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
};

// Convert time to minutes for easier comparison
const convertTimeToMinutes = (time) => {
  const [hour, minute] = time.split(":").map(Number);
  return hour * 60 + minute;
};

// Get current time in minutes
const getCurrentTimeInMinutes = () => {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes();
};

// Convert availability data to dropdown format
const convertAvailabilityToDropdown = (availability) => {
  return availability.map((dayData) => {
    const { day, is_available, on_timing } = dayData;
    if (is_available && on_timing.length > 0) {
      const timeSlots = on_timing.map((timing) => ({
        start: convertTimeTo12Hour(timing.start),
        end: convertTimeTo12Hour(timing.end),
        startMinutes: convertTimeToMinutes(timing.start),
        endMinutes: convertTimeToMinutes(timing.end),
      }));
      return { day, timeSlots };
    } else if (is_available) {
      return {
        day,
        timeSlots: [
          {
            start: "Open 24 hours",
            end: "",
            startMinutes: 0,
            endMinutes: 1440,
          },
        ],
      };
    } else {
      return {
        day,
        timeSlots: [
          { start: "Closed", end: "", startMinutes: 0, endMinutes: 0 },
        ],
      };
    }
  });
};

// Get today's day
const getTodayDay = () => {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const todayIndex = new Date().getDay();
  return days[todayIndex];
};

// React component to render the dropdown
const AvailabilityDropdown = ({ availability }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [today, setToday] = useState("");

  useEffect(() => {
    setToday(getTodayDay());
  }, []);

  const dropdownData = convertAvailabilityToDropdown(availability);

  // Check if there's any availability data
  const hasAvailability = dropdownData.length > 0;

  // Get current time in minutes
  const currentTimeInMinutes = getCurrentTimeInMinutes();

  return (
    <div>
      <div className="d-flex align-items-center gap-3">
        <div className="">
          {hasAvailability ? (
            dropdownData
              .filter((item) => item.day === today)
              .map((item, index) =>
                item.timeSlots.map((slot, idx) => (
                  <div
                    key={`${index}-${idx}`}
                    style={{
                      color:
                        currentTimeInMinutes >= slot.startMinutes &&
                        currentTimeInMinutes <= slot.endMinutes
                          ? 'green'
                          : 'red'
                    }}
                  >
                    {slot.start} {slot.end && `- ${slot.end}`} (
                    {currentTimeInMinutes >= slot.startMinutes &&
                    currentTimeInMinutes <= slot.endMinutes
                      ? 'Open'
                      : 'Closed'}
                    )
                  </div>
                ))
              )
          ) : (
            <div>Timing is not available</div>
          )}
        </div>
        {hasAvailability && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <Icon
              icon={
                isExpanded ? 'teenyicons:up-solid' : 'teenyicons:down-solid'
              }
            />
          </button>
        )}
      </div>
      {isExpanded && hasAvailability && (
        <div className="time-slot-listing-items">
          {dropdownData.map((item, index) =>
            item.timeSlots.map((slot, idx) => (
              <div
                key={`${index}-${idx}`}
                className="time-slot-listing-item"
              >
                {item.day}: {slot.start} {slot.end && `- ${slot.end}`} (Open)
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AvailabilityDropdown;
